(function() { window.GUID_e0c5c451_a160_4ff7_be2e_641f1c438c83 = { getGuid: function() { return "e0c5c451-a160-4ff7-be2e-641f1c438c83"; } }; })();


//# sourceMappingURL=IHasChanged.js.map
